import Layout from '@/views/Layout.vue';
import routesLogin from './login.routes';
import routesAccounts from './accounts.routes';
import firstLogin from './firstlogin.routes';
import routesDashboard from './dashboard.routes';
import routesGlobal from './global.routes';

export default [
    {
        path: '/',
        component: Layout,
        children: []
            .concat(routesLogin)
            .concat(routesAccounts)
            .concat(firstLogin)
            .concat(routesDashboard)
            .concat(routesGlobal)
    }
];
